module.exports = __webpack_public_path__ + "img/suspicious_vehicle_at_park.23b20757.jpg";